import styled from 'styled-components'

export const LoginAdContent = styled.div`
  width: 100%;
  margin-bottom: 16px;
  button {
    width: 100%;
  }
  .ant-form label {
    padding-bottom: 0px !important;
  }
`
export const LoginIprojectSystemContent = styled.div`
  margin-top: 16px;
`
export const AnimationSlider = styled.div`
  max-width: 343px;
  width: 100%;

  .login-ad-active {
    height: 220px;
    min-height: fit-content !important;
    opacity: 1;
    transition: 450ms ease-in-out;
  }
  .login-ad-inactive {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    transition: 450ms ease-in-out;
  }

  .login-iproject-active {
    height: 270px;
    opacity: 1;
    transition: 450ms ease-in-out;
  }
  .login-iproject-inactive {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    transition: 450ms ease-in-out;
  }
  .or-style {
    display: grid;
    grid-template-columns: 3fr 1fr 3fr;
    grid-gap: 8px;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 24px;
    width: 166px;
    .line {
      display: flex;
      height: 1px;
      width: 100%;
      background-color: #858585;
    }
  }
  .ant-input-prefix {
    .anticon {
      color: #127ec3 !important;
    }
  }
`
